import { UserRoles } from '@/enums/enums';
import { getUserOptions } from '@/features/user/user.queries';
import { createFileRoute, redirect } from '@tanstack/react-router';

import GradesTab from './-GradesTab';

export const Route = createFileRoute('/_app/(account)/account/grades')({
  component: AccountGradesPage,
  beforeLoad: async ({ context }) => {
    const { user } = await context.queryClient.ensureQueryData(getUserOptions);

    if (![UserRoles.Root, UserRoles.Admin].includes(user?.role as UserRoles)) {
      throw redirect({ to: '/' });
    }
  },
});

function AccountGradesPage() {
  return (
    <div className='flex h-full flex-col'>
      <div className='flex flex-col px-6 pb-2 pt-4'>
        <h1 className='text-xl font-bold tracking-tight'>Στατιστικά Βαθμολογίας</h1>
        <p className='mt-0.5 text-sm text-muted-foreground'>
          Επισκόπηση βαθμών μαθημάτων, περιόδων και παρουσιών.
        </p>
      </div>

      <div className='flex-1 overflow-y-auto'>
        <GradesTab />
      </div>
    </div>
  );
}

export default AccountGradesPage;
